import React, { useState } from 'react'
import { isMobileOnly } from 'react-device-detect'
import { InfoBox, SettingsWrapper } from '../components/common'
import { useTranslate } from '@ur-solutions/react-hooks'
import { useModuleConfigs } from '../hooks'
import { ExportActivitiesForSalaryCard } from '../components/ExportsSettings/ExportActivitiesForSalaryCard'

interface SalaryExportProps {}

export const SalaryExport: React.FC<SalaryExportProps> = () => {
  const translations = useTranslate({
    info1: 'settings.info.salary-exports-1',
  })

  const [loading, setLoading] = useState(false)

  function handleLoadingChanged(formLoading: boolean) {
    setLoading(formLoading)
  }

  const { active } = useModuleConfigs()

  return (
    <SettingsWrapper
      grid={{
        flow: 'row',
      }}
    >
      <InfoBox initCollapsed={isMobileOnly}>
        <p>{translations.info1}</p>
      </InfoBox>

      {active.activities && (
        <ExportActivitiesForSalaryCard
          loading={loading}
          onLoadingChange={handleLoadingChanged}
        />
      )}
    </SettingsWrapper>
  )
}
